import React, { useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import styled from "styled-components";
import useApi, {useApi_file} from "../../hooks/api/axiosInterceptor";

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: solid 1px #000;
  border-radius: 4px;
`;

const FormGroup = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

const TextArea = styled.textarea`
  width: 100%;
  height: 300px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

const FileList = styled.ul`
  margin-top: 10px;
  list-style: none;
  padding: 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const Button = styled.button`
  padding: 8px 16px;
  background-color: ${props => props.primary ? '#007bff' : '#6c757d'};
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  
  &:hover {
    background-color: ${props => props.primary ? '#0069d9' : '#5a6268'};
  }
`;

const CreateBoardPostNews = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [post, setPost] = useState({ title: '', content: '' });
    const [files, setFiles] = useState([]);

    // URL에서 경로 정보 추출
    const pathSplit = location.pathname.split('/');
    // /news/student-council/write 형태에서 [, 'news', 'student-council', 'write']
    const b_part = pathSplit[2] || ''; // 'student-council'
    const mainCategory = pathSplit[1] || ''; // 'news'

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPost(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const selected = Array.from(e.target.files);
        if (files.length + selected.length > 10) {
            alert("첨부파일은 최대 10개까지 등록할 수 있습니다.");
            return;
        }
        setFiles(prev => [...prev, ...selected]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!post.title.trim()) {
            alert("제목을 입력해주세요.");
            return;
        }

        const formData = new FormData();
        formData.append("board", b_part);
        formData.append("title", post.title);
        formData.append("content", post.content);
        files.forEach((file, idx) => {
            formData.append("file", file);
        });

        try {
            const response = await useApi_file.post('/create_board', formData);
            if (response.data.result === 'SUCCESS') {
                alert("게시글이 등록되었습니다.");
                navigate(`/news/${b_part}`);
            } else {
                alert("오류: " + response.data.message);
            }
        } catch (err) {
            alert("API 오류: " + err.message);
        }
    };

    return (
        <Wrapper>
            <h2>게시글 작성</h2>
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                <FormGroup>
                    <Label htmlFor="title">제목</Label>
                    <Input type="text" id="title" name="title" value={post.title} onChange={handleChange} />
                </FormGroup>
                <FormGroup>
                    <Label htmlFor="content">내용</Label>
                    <TextArea id="content" name="content" value={post.content} onChange={handleChange} />
                </FormGroup>
                <FormGroup>
                    <Label>첨부파일 (최대 10개)</Label>
                    <Input type="file" multiple onChange={handleFileChange} />
                    <FileList>
                        {files.map((file, index) => (
                            <li key={index}>{file.name}</li>
                        ))}
                    </FileList>
                </FormGroup>
                <ButtonGroup>
                    <Button type="submit" primary>등록</Button>
                </ButtonGroup>
            </form>
        </Wrapper>
    );
};

export default CreateBoardPostNews;
